import {DEFAULT_SHELL_HEIGHT} from '../constants'

export type ShellPoint = {
  x: number
  y: number
}

export const getShellCenterY = (diameter?: number, shellHeight: number = DEFAULT_SHELL_HEIGHT) => {
  const safeDiameter = diameter ?? 0
  return (shellHeight - safeDiameter) / 2
}

export const buildShellPolygon = (
  cones:
    | Array<{
        dimensions: {distanceFrom0?: number; width?: number; diameter?: number}
      }>
    | undefined,
  kilnLength: number,
  meterToPixel: number,
  kilnDiameter?: number,
  heightPerMeterInPixel?: number,
  shellHeight: number = DEFAULT_SHELL_HEIGHT
) => {
  const safeLength = Math.max(kilnLength, 1)
  const hScale = heightPerMeterInPixel ?? 1
  const radius = 10

  const sortedCones = [...(cones ?? [])].sort(
    (a, b) => (a.dimensions.distanceFrom0 ?? 0) - (b.dimensions.distanceFrom0 ?? 0)
  )

  const getYTop = (diameter?: number) => getShellCenterY((diameter ?? 0) * hScale, shellHeight)
  const getYBottom = (diameter?: number) => {
    const d = (diameter ?? 0) * hScale
    const topY = getShellCenterY(d, shellHeight)
    return topY + d
  }

  const topPoints: ShellPoint[] = []
  const bottomPoints: ShellPoint[] = []

  const addPoints = (x: number, diameter?: number) => {
    topPoints.push({x: x * meterToPixel, y: getYTop(diameter)})
    bottomPoints.push({x: x * meterToPixel, y: getYBottom(diameter)})
  }

  const firstDiameter = kilnDiameter ?? sortedCones[0]?.dimensions.diameter ?? 0
  let lastEnd = 0
  let currentDiameter = firstDiameter

  addPoints(0, currentDiameter)

  sortedCones.forEach((cone) => {
    const coneStart = cone.dimensions.distanceFrom0 ?? 0
    const coneWidth = cone.dimensions.width ?? 0
    const coneEnd = coneStart + coneWidth
    const coneDiameter = cone.dimensions.diameter ?? 0

    if (coneStart > lastEnd) {
      addPoints(coneStart, currentDiameter)
    }

    addPoints(coneStart, currentDiameter)
    addPoints(coneEnd, coneDiameter)

    lastEnd = coneEnd
    currentDiameter = coneDiameter
  })

  if (safeLength > lastEnd) {
    addPoints(safeLength, currentDiameter)
  }

  const startTop = topPoints[0]
  const startBottom = bottomPoints[0]
  const endTop = topPoints[topPoints.length - 1]
  const endBottom = bottomPoints[bottomPoints.length - 1]

  let path = `M ${startTop.x + radius} ${startTop.y} `

  for (let i = 1; i < topPoints.length - 1; i++) {
    path += `L ${topPoints[i].x} ${topPoints[i].y} `
  }

  path += `L ${endTop.x - radius} ${endTop.y} `
  path += `Q ${endTop.x} ${endTop.y} ${endTop.x} ${endTop.y + radius} `
  path += `L ${endBottom.x} ${endBottom.y - radius} `
  path += `Q ${endBottom.x} ${endBottom.y} ${endBottom.x - radius} ${endBottom.y} `

  for (let i = bottomPoints.length - 2; i >= 1; i--) {
    path += `L ${bottomPoints[i].x} ${bottomPoints[i].y} `
  }

  path += `L ${startBottom.x + radius} ${startBottom.y} `
  path += `Q ${startBottom.x} ${startBottom.y} ${startBottom.x} ${startBottom.y - radius} `
  path += `L ${startTop.x} ${startTop.y + radius} `
  path += `Q ${startTop.x} ${startTop.y} ${startTop.x + radius} ${startTop.y} `
  path += 'Z'

  return path
}
